// @ts-check
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { TakeParentConfigButton } from './TakeParentConfigButton';
import { LBButton } from '@linearb/buzz';

const PMIncidentsHeader = ({
  disableSave,
  onSave,
  onRestore,
  isTeamSetting,
  parentName,
  onUseParentConfig,
  isUsingParentConfig
}) => {
  return (
    <Flex direction='column' pb='2rem' pt='2rem'>
      <Flex direction='row' justify='space-between'>
        <Text
          weight='500'
          size='large'
          lineHeight='2rem'
          letterSpacing='0.3px'
          color='shark'
        >
          {isTeamSetting ? 'TEAM SPECIFIC' : ''} INCIDENTS DETECTION
        </Text>
        <div className='flex flex-row gap-2'>
          {isTeamSetting ? (
            <TakeParentConfigButton
              isUsingParentConfig={isUsingParentConfig}
              onUseParentConfig={onUseParentConfig}
              parentName={parentName}
            />
          ) : (
            <LBButton variant='outline' onClick={onRestore}>
              Restore Default
            </LBButton>
          )}
          <LBButton disabled={disableSave} onClick={onSave}>
            Save
          </LBButton>
        </div>
      </Flex>
      <Text
        size='medium'
        weight='400'
        lineHeight='2rem'
        color='shuttleGray'
        letterSpacing='0.2px'
      >
        Select the way you would like LinearB to detect incidents for your team.
        <br /> <span style={{ fontWeight: '700' }}>Note:</span> This change will
        affect how LinearB calculates CFR and MTTR.
      </Text>
      <Separator
        direction='horizontal'
        width='100%'
        height='1px'
        margin='2rem 0 0 0'
      />
    </Flex>
  );
};

export default PMIncidentsHeader;
